import { render, staticRenderFns } from "./OrderStatusForCompany.vue?vue&type=template&id=556f8a80&scoped=true&"
import script from "./OrderStatusForCompany.vue?vue&type=script&lang=js&"
export * from "./OrderStatusForCompany.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusForCompany.vue?vue&type=style&index=0&id=556f8a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556f8a80",
  null
  
)

export default component.exports